import { CommonModule, NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import {
 Component,
 Input,
 effect,
 inject,
 OnInit,
 EventEmitter,
 Output,
 PLATFORM_ID,
 Inject,
 WritableSignal,
 signal,
 DestroyRef,
} from '@angular/core';
import { AvailableDateModel, RoomModel, RoomsApiModel } from '@core/models/domains/room';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { PdpDatepickerComponent } from '../../components/pdp-datepicker/pdp-datepicker.component';
import { PdpEmptyViewComponent } from '../../components/pdp-empty-view/pdp-empty-view.component';
import { PdpRoomsCardsComponent } from '../../components/pdp-rooms-cards/pdp-rooms-cards.component';
import { PdpRoomsFiltersComponent } from '../../components/pdp-rooms-filters/pdp-rooms-filters.component';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-pdp-rooms-wrapper',
 standalone: true,
 imports: [
  NgIf,
  NgFor,
  CommonModule,
  PdpRoomsFiltersComponent,
  PdpRoomsCardsComponent,
  PdpDatepickerComponent,
  PdpEmptyViewComponent,
  DatepickerComponent,
  PersianToEnglishRegexPipe,
  PdpEmptyViewComponent,
 ],
 templateUrl: './pdp-rooms-wrapper.component.html',
 styleUrls: ['./pdp-rooms-wrapper.component.scss'],
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdpRoomsWrapperComponent {
 autocompleteService = inject(AutocompleteService);
 // @Input() isActive:boolean = true;
 @Input() cityId: string = '';
 @Output() goToSimilarHotelsSection: any = new EventEmitter<any>();
 @Input() set dataSource(ds: RoomsApiModel) {
  if (ds) {

   this._dataSource = ds;
   this.filteredRooms = ds.room?.roomContainer;
   this.datePickerService.setNightLimit(ds.limitCountNights || 0);
  }
 }

 goToSimilarHoptelsSection() {
  this.goToSimilarHotelsSection.emit();
 }

 _dataSource?: RoomsApiModel;
 isSafarMarket = false;
 hotelId = 0;
 // @Input() dataSource: RoomsApiModel = {} as RoomsApiModel
 filteredRooms?: RoomModel[];
 activeFiltersResetTrigger = false;
 pdpUiService = inject(HotelInfoUiService);
 showSearchBar: boolean = false;
 datePickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 destroyRef = inject(DestroyRef);
 autoCompleteService = inject(AutocompleteService);
 persianToEnglishRegexPipe = inject(PersianToEnglishRegexPipe);
 route = inject(ActivatedRoute);
 router = inject(Router);
 activeFilters: Array<number> = [];
 @Output() goToRoomSectionInPdp = new EventEmitter();

 constructor() {
  effect(() => {
   let rayChat: HTMLElement = document.getElementById('raychat_widget') as HTMLElement;
   if (!rayChat) return;

   if (this.datePickerService._state()) {
    let rayChat: HTMLElement = document.getElementById('raychat_widget') as HTMLElement;
    rayChat?.classList.add('hidden');
   } else {
    let rayChat: HTMLElement = document.getElementById('raychat_widget') as HTMLElement;
    rayChat?.classList.remove('hidden');
   }
  });

  effect(() => {
   this.activeFilters = this.pdpUiService.activeRoomFiltersIds();

   if (!this.activeFilters?.length) {
    this.filteredRooms = this._dataSource?.room?.roomContainer;
   } else this.filteredRooms = this.filterRooms();
  });

  this.hotelId = this.pdpUiService.hotelId;
 }
 ngOnInit(): void {
  this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
   if (params['safarmarketId']) this.isSafarMarket = true;
  });
 }

 resetFilters() {
  this.activeFiltersResetTrigger = !this.activeFiltersResetTrigger;
  this.pdpUiService.activeRoomFiltersIds.set([]);
  this.pdpUiService.activeRoomFiltersNames.set([]);
 }

 filterRooms(): RoomModel[] {
  return (
   this._dataSource?.room?.roomContainer.filter((room) => {
    return this.activeFilters.every((filterId) => {
     return room.filterIds.includes(filterId);
    });
   }) || ([] as RoomModel[])
  );
 }

 setToggle() {
  this.showSearchBar = !this.showSearchBar;
  //this.searchBoxService.mobileSearchBoxIsOpen.next(!this.toggle)
 }

 closeDatepicker(event: any) {
  if (!event.target.closest('.iho-datepicker')) {
   this.datePickerService.setAllowToShow(true);
  }
 }

 goToRoomSection() {
  this.goToRoomSectionInPdp.emit();
 }

 openDatePicker(event: any[]) {
  let helper: string[] = [];
  /*
         - checking first item
      */
  if (+event[0].reservableStatus === 2 || +event[0].reservableStatus === 3) {
   helper.push(`${this.persianToEnglishRegexPipe.transform(event[0].datePersian)},3`);
  }
  if (+event[0].reservableStatus === 4) {
   helper.push(`${this.persianToEnglishRegexPipe.transform(event[0].datePersian)},4`);
  }
  if (+event[0].reservableStatus === 5) {
   helper.push(`${this.persianToEnglishRegexPipe.transform(event[0].datePersian)},2`);
  }
  for (let i = 1, j = 0, k = 2; i < event?.length; i++, j++, k++) {
   if (
    +event[i].reservableStatus === 2 &&
    +event[j].reservableStatus === 2 &&
    +event[k]?.reservableStatus === 2
   ) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},2`);
   }
   if (
    +event[i].reservableStatus === 2 &&
    +event[j].reservableStatus === 2 &&
    +event[k]?.reservableStatus === 1
   ) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},2`);
   }
   if (
    +event[i].reservableStatus === 2 &&
    +event[j].reservableStatus === 1 &&
    +event[k]?.reservableStatus === 2
   ) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},3`);
   }
   if (+event[i].reservableStatus === 3) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},3`);
   }
   if (+event[i].reservableStatus === 4) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},4`);
   }
   if (+event[i].reservableStatus === 5) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},2`);
   }
   /*
           - checking last item
         */
   if (
    +event[i].reservableStatus === 2 &&
    +event[j].reservableStatus === 1 &&
    event[k] === undefined
   ) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},2`);
   }
   if (
    +event[i].reservableStatus === 2 &&
    +event[j].reservableStatus === 2 &&
    event[k] === undefined
   ) {
    helper.push(`${this.persianToEnglishRegexPipe.transform(event[i].datePersian)},2`);
   }
  }
  this.datePickerService.setUnReservable(helper, true);
 }

 getRoomsWithNewDate() {
  this.goToRoomSection();
  this.datePickerService.setAllowToShow(true);
  this.datePickerService.setState(false);
  let parameters = {
   id: this.autoCompleteService._selectedItem().id,
   type: this.autoCompleteService._selectedItem().type,
   link: this.autoCompleteService._selectedItem().link,
   name: this.autoCompleteService._selectedItem().name,
   state: this.autoCompleteService._selectedItem()?.state,
   startDate: this.datePickerService._startDate(),
   endDate: this.datePickerService._endDate(),
  };
  if (parameters.id !== this.hotelId) {
   this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
  } else {
   // this.pdpUiService.getRooms()

   this.router
    .navigate([], {
     queryParams: {
      date: parameters.startDate,
      endDate: parameters.endDate,
     },
     queryParamsHandling: 'merge',
     relativeTo: this.route,
     // fragment: 'rooms',
     preserveFragment: true,
    })
    .finally(() => this.pdpUiService.getRooms());
  }
 }
}
